import { createSelector } from 'reselect';

import { pickupFeatureMap } from 'shared/app/state/selectors/ordering';

const orderingSelector = (state) => state?.ordering?.order;

export const currentPickupOptionSelector = createSelector(
  orderingSelector,
  (ordering) => ordering?.pickupOption
);

export const currentSelectedPickupOptionNameSelector = createSelector(
  currentPickupOptionSelector,
  (currentPickupOption) => {
    return pickupFeatureMap[currentPickupOption]?.name;
  }
);

export const previousPickupOptionSelector = createSelector(
  orderingSelector,
  (ordering) => ordering?.previous?.pickupOption
);
